import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Login/login';
export var LoginMainFooter = function LoginMainFooter(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$socialMediaLoginCo = _a.socialMediaLoginContent,
      socialMediaLoginContent = _a$socialMediaLoginCo === void 0 ? null : _a$socialMediaLoginCo,
      _a$signUpForAccountMe = _a.signUpForAccountMessage,
      signUpForAccountMessage = _a$signUpForAccountMe === void 0 ? null : _a$signUpForAccountMe,
      _a$forgotCredentials = _a.forgotCredentials,
      forgotCredentials = _a$forgotCredentials === void 0 ? null : _a$forgotCredentials,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      props = __rest(_a, ["children", "socialMediaLoginContent", "signUpForAccountMessage", "forgotCredentials", "className"]);

  return React.createElement("div", Object.assign({
    className: css(styles.loginMainFooter, className)
  }, props), children, socialMediaLoginContent && React.createElement("ul", {
    className: css(styles.loginMainFooterLinks)
  }, socialMediaLoginContent), (signUpForAccountMessage || forgotCredentials) && React.createElement("div", {
    className: css(styles.loginMainFooterBand)
  }, signUpForAccountMessage, forgotCredentials));
};